import {
  ChangeDetectionStrategy,
  Component,
  inject,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { SubscriberAdsModule } from '../../subscriber-ads.module';
import { BaseSubscriberAdsComponent } from '../../abstract-components/base-subscriber-ads.component';
import { filter, tap } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';
import { TrackService } from '~app/app/~shared/services/track.service';

@Component({
  selector: 'subscriber-ads-list-page',
  standalone: true,
  imports: [SubscriberAdsModule],
  templateUrl: './subscriber-ads-list-page.component.html',
  styleUrl: './subscriber-ads-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdsListPageComponent
  extends BaseSubscriberAdsComponent
  implements AfterContentInit, OnDestroy
{
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);
  private _trackService = inject(TrackService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      title: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }

  onFilterChange(filters: Record<string, unknown>): void {
    this._resourceFacade.applyFilters(filters);
    this._resourceFacade.getData({ refresh: true });
  }
}
